import { useTranslation } from "hooks/useTranslation";
import Head from "layout/Head";
import React, { Fragment } from "react";
import {
  DEPLOYMENT_HERO_CONFIG,
  MASSIVE_SCALE_DEPLOYMENT_MOBILE_CONFIG,
  MASSIVE_SCALE_DEPLOYMENT_SWITCHING_TAB,
} from "./MassiveScaleDeployment.config";
import { ModelCompareTab } from "../GettingStartedWithUniFi.types";
import { PhysicalSecurityOverview } from "constants/modelCompareData/data/PhysicalSecurityOverview";
import { ExtendedTabId } from "components/ExtendedTabs/ExtendedTabs.types";
import { WifiOverview } from "constants/modelCompareData/data/WiFiOverview";
import { SwitchingEnterprise } from "constants/modelCompareData/data/SwitchingEnterprise";
import { HowItWorksPage } from "components/HowItWorksPage";
import { MODEL_COMPARE_TABS } from "../shared.config";

import largeScaleRiv from "../assets/rive/large-scale.riv";
import largeScaleMobileRiv from "../assets/rive/large-scale-mobile.riv";

const MODEL_COMPARE_DATA_BY_ID = {
  [ModelCompareTab.Switching]: SwitchingEnterprise,
  [ModelCompareTab.AccessPoints]: WifiOverview,
  [ModelCompareTab.Cameras]: PhysicalSecurityOverview,
  [ModelCompareTab.DoorAccess]: null,
};

export const MassiveScaleDeployment = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Head
        title={t("gettingStartedWithUniFi.seo.title")}
        description={t("gettingStartedWithUniFi.seo.description")}
        url="https://ui.com/how-it-works/massive-scale"
        image="https://www.ui.com/microsite/og-image.png"
      />

      <HowItWorksPage
        hero={{
          title: "gettingStartedWithUniFi.hero.title",
          config: DEPLOYMENT_HERO_CONFIG,
          mobileConfig: MASSIVE_SCALE_DEPLOYMENT_MOBILE_CONFIG,
          isSimpleHero: true,
        }}
        topology={{
          title: "gettingStartedWithUniFi.topology.intro.title",
          description: "gettingStartedWithUniFi.topology.intro.description",
          config: {
            src: largeScaleRiv,
            aspectRatio: "1100/1294",
          },
          mobileConfig: {
            src: largeScaleMobileRiv,
            aspectRatio: "432/1250",
          },
        }}
        activePageId={ExtendedTabId.MassiveScaleDeployment}
        compareTabs={[
          MASSIVE_SCALE_DEPLOYMENT_SWITCHING_TAB,
          ...MODEL_COMPARE_TABS,
        ]}
        compareOptions={MODEL_COMPARE_DATA_BY_ID}
      />
    </Fragment>
  );
};
